import React from "react";
import { Helmet } from "react-helmet-async";

export interface ISeoProps {
    title: string;
    description: string;
    path: string;
    noindex?: boolean;
}

export class Seo extends React.Component<ISeoProps, {}> {
    public render() {
        const url = `https://valerekissi.com${this.props.path}`;
        return (
            <Helmet defer={false}>
                <title>{this.props.title}</title>
                <meta name="description" content={this.props.description} />
                <link rel="canonical" href={url} />
                <meta property="og:title" content={this.props.title} />
                <meta property="og:description" content={this.props.description} />
                <meta property="og:url" content={url} />
                {this.props.noindex && <meta name="robots" content="noindex" />}
            </Helmet>
        );
    }
}
